var _clipPath;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTypographiAwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 503 86",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-174.009,-382.607l850.394,0l0,850.394l-850.394,0l0,-850.394l0,0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.765,1.358l-30.986,82.34l24.073,0l20.245,-61.353l20.369,61.353l24.072,0l-31.108,-82.34l-26.665,0l0,0Zm-54.934,53.7l0,6.42c-2.963,2.469 -9.135,4.937 -15.184,4.937c-13.457,0 -22.962,-10.369 -22.962,-23.825c0,-13.456 9.505,-23.826 22.962,-23.826c8.024,0 14.32,5.062 17.406,10.494l17.777,-9.259c-5.679,-10.246 -16.789,-19.999 -35.183,-19.999c-24.567,0 -44.565,16.419 -44.565,42.59c0,26.171 19.998,42.59 44.565,42.59c15.554,0 27.529,-6.296 36.417,-16.049l0,-30.116l-21.233,0l0,16.043Zm253.436,-53.7l-26.665,0l-30.987,82.34l24.074,0l20.244,-61.353l20.37,61.353l24.072,0l-31.108,-82.34l0,0Zm-100.115,63.823l-13.334,0l0,-45.305l13.457,0c15.06,0 22.714,9.876 22.714,22.59c0,12.222 -8.395,22.715 -22.837,22.715m0,-63.823l-34.566,0l0,82.34l34.689,0c25.8,0 44.441,-15.678 44.441,-41.232c0,-25.553 -18.641,-41.108 -44.564,-41.108m-322.91,0l-10.934,0l-18.735,0l0,18.518l29.669,0c5.113,0 9.259,4.145 9.259,9.258c0,5.114 -4.146,9.259 -9.259,9.259l-29.669,0l0,18.518l21.443,0l14.243,26.787l21.12,0l-15.591,-29.324c9.569,-4.385 16.23,-14.024 16.23,-25.24c0,-15.34 -12.436,-27.776 -27.776,-27.776m-48.242,74.07l18.518,0l0,-18.518l-18.518,0l0,18.518Zm9.259,-37.035l9.259,0l0,-9.259l-9.259,0l0,9.259Zm80.31,45.305l60.366,0l0,-18.517l-39.133,0l0,-13.95l20.616,0.022l0,-18.517l-20.616,-0.022l0,-12.838l39.133,0l0,-18.518l-60.366,0l0,82.34Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTypographiAwhite);
export default __webpack_public_path__ + "static/media/logoTYPOGRAPHIAwhite.24ea2012c52fbbeae567241eea44b6c4.svg";
export { ForwardRef as ReactComponent };